import { Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';

import type { ChargingPile } from '@/types/database/chargingPile/chargingPile';

import { GroupContext } from '../../../PileCtxProvider';
import PileCard from '../PileCard';

const CurrentGroupChildren: React.FC = () => {
  const { currentGroup, chargingPileData, sortBy } = useContext(GroupContext);
  const [currentChildrenPiles, setCurrentChildrenPiles] = useState<
    ChargingPile[]
  >([]);

  useEffect(() => {
    if (currentGroup) {
      setCurrentChildrenPiles(
        chargingPileData
          .filter((pile: ChargingPile) =>
            currentGroup.children.includes(pile._id)
          )
          .sort((a, b) => {
            const propertyA = a[sortBy];
            const propertyB = b[sortBy];
            if (
              typeof propertyA === 'string' &&
              typeof propertyB === 'string'
            ) {
              return propertyA.localeCompare(propertyB);
            } else if (typeof propertyA === 'string') {
              return -1;
            }
            return 1;
          })
      );
    }
  }, [currentGroup, chargingPileData, sortBy]);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, 265px)',
        gridTemplateRows: 'repeat(auto-fill, 1fr)',
        gap: '10px',
        overflow: 'auto',
        pr: '10px',
      }}
    >
      {currentChildrenPiles.map((pile) => (
        <PileCard key={pile._id} pile={pile} />
      ))}
    </Box>
  );
};

export default CurrentGroupChildren;
